import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: "AIzaSyBpHMmGdwnP8frmglM-uzaxjswOvOvnJjU",
  authDomain: "lecomptoir-fc74f.firebaseapp.com",
  databaseURL: "https://lecomptoir-fc74f.firebaseio.com",
  projectId: "lecomptoir-fc74f",
  storageBucket: "lecomptoir-fc74f.appspot.com",
  messagingSenderId: "211770653562",
  appId: "1:211770653562:web:b08db0f6bc280f56"
};
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser



// firebase collections
const usersCollection = db.collection('users')

export {
  db,
  auth,
  currentUser,
  usersCollection
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js